import * as React from 'react';
/**
 *
 * Original name: pointer
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=28656%3A6740
 *
 */
export const PointerLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12.175 7.175c-.301.301-.57.82-.65 1.736L10 9.419C10.027 6.446 11.5 5 14.5 5 17.528 5 19 6.472 19 9.5c0 3-1.446 4.473-4.419 4.5l.508-1.524c.917-.08 1.434-.35 1.736-.651.36-.36.675-1.031.675-2.325 0-1.293-.315-1.964-.675-2.325-.36-.36-1.032-.675-2.325-.675-1.294 0-1.964.314-2.325.675Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m11 20-2.45-4.55L4 13l10.5-3.5L11 20Zm-.325-3.768-1.018-1.89-1.89-1.017 4.361-1.453-1.453 4.36Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
